<template>
    <div class="flex">
        <div v-for="country in countries" :key="country" class="mr-1" v-tooltip="country">
            <country-flag :country="country" :size="size"/>
        </div>
    </div>
</template>

<script>
    import CountryFlag from 'vue-country-flag';

    export default {
        components: {
            CountryFlag,
        },
        props: {
            countries: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            size: {
                type: String,
                default: 'small'
            }
        },
    }
</script>
